<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">Drivers Map</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">Drivers Map</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-2 col-lg-2 p-0">
                  <!--<div class="m-3 form-ddown">-->
                    <!--<label class="search-label">Start</label>-->
                    <datetime type="datetime" v-model="min_date" input-class="form-control form-control-sm" placeholder="Start" label="Start" :noClearButton="false">
                    </datetime>
                    <!--<font-awesome-icon v-if="min_date" @click="clearDate('min_date')" icon="times" style="color: red; cursor: pointer"/>-->
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp
                to
                &nbsp&nbsp&nbsp
                <div class="col-md-2 col-lg-2 p-0">
                  <!--<div class="m-3 form-ddown">-->
                    <!--<label class="search-label">End</label>-->
                    <datetime type="datetime"  v-model="max_date" label="End" input-class="form-control form-control-sm" placeholder="Now" >
                    </datetime>
                    <font-awesome-icon v-if="max_date" @click="clearDate('max_date')" icon="times" style="color: red; cursor: pointer"/>
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp

                <div class="col-md-1 col-lg-1 m-0 p-0">
                  <!--<div class="m-3">-->
                    <!--<label class="search-label">Select a Market</label>-->
                    <select type="text" placeholder="Market" v-model="selected_market"
                            class="form-control ddown" id="rider-filter">
                      <option value="all">All markets</option>
                      <option v-for="item in markets">
                        {{item.name}}
                      </option>
                    </select>
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp
                <div class="col-md-1 col-lg-1 p-0">
                  <!--<div class="m-3">-->
                    <!--<label class="search-label">Select a Status</label>-->
                    <select type="text" placeholder="Status"
                            class="form-control ddown" id="status-filter" v-model="selected_status">
                      <option value="all">All statuses</option>
                      <option value="en_route">En-route</option>
                      <option value="picked_up">Picked-up</option>
                    </select>
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp

                <div class="col-md-1 col-lg-1 p-0">
                  <!--<div class="m-2">-->
                  <!--<label class="search-label">First Name</label>-->
                  <input v-model="id_driver" class="form-control" placeholder="Driver ID" style="width:100%" type="text"
                         name="id_driver" id="id_driver" maxlength="20">
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp

                <!--<div class="col-md-1 col-lg-1 p-0 submit-button">-->
                  <button v-on:click="buttonSearch(currentPage)" class="btn btn-secondary waves-effect waves-light m-t-10">Reset</button>
                &nbsp&nbsp&nbsp
                  <button v-on:click="searchDriverLocations()" class="btn btn-info waves-effect waves-light m-t-10">Search</button>
                <!--</div>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

      <div class="col-12 col-lg-12" style="padding: 0;">
        <div class="card">
        <div class="card-body card-map-body" style="padding: 0;">
          <span>{{map_info}}</span>
          <div class="d-flex">
            <div id="map" style="width: 100%;height: 500px;margin: auto;"></div>
          </div>
        </div>
        </div>
      </div>




    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="result">

              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                  <tr>
                    <th class="result-label">
                      Driver ID
                    </th>
                    <th class="result-label">
                      Name
                    </th>
                    <th class="result-label">
                      GPS-coordinates
                    </th>
                    <th class="result-label">
                      Last active at
                    </th>
                  </tr>
                  </thead>
                  <tbody class="col-12">
                  <tr v-for="lo in driversLocations">
                    <td class="text-primary result-item">
                      <router-link :to="'/drivers/' + lo.id_user.id_user + '/'">
                        {{ lo.id_user.id_user }}
                      </router-link>
                    </td>
                    <td class="result-item">
                      {{ lo.id_user.name_first + ' ' + lo.id_user.name_last }}
                    </td>
                    <td class="result-item">
                      {{ lo.lat + ',' + lo.lng }}
                    </td>
                    <td class="result-item">
                      {{ moment(lo.created_at).fromNow() + ' (' + moment(lo.created_at).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz.guess() + ")" + ')'}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</div>

</template>

<script>
  import Vue from 'vue'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Drivers',
    },
    name: 'Drivers',
    data () {
      return {
        isLoading: false,
        loadings: [],
        driver: null,
        prev: null,
        upco: null,
        comments: [],
        comment_content: null,
        status_list: null,
        selected: 1,
        payments: null,
        balance: null,
        map: null,
        showCancel: false,
        showSave: false,
        showDraw: true,
        shapes: [],
        lines: [],
        oldDrawing: null,
        selected_status: 'all',
        selected_market: 'all',
        min_date: null,
        max_date: null,
        id_driver: null,
        markets: null,
        map_info: null,
        drawnMarkers: [],
        driversLocations: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      showLoading() {
        this.isLoading = true
        this.loadings.push(1)
      },
      hideLoading() {
        if (this.loadings.length > 0) {
          this.loadings.pop()
        }
        if (this.loadings.length == 0) {
          this.isLoading = false
        }
      },
      clearDate(type) {
        if (type == 'max_date') {
          this.max_date = null;
        }
      },
      clearMarkers() {
        for (let i = 0; i < this.drawnMarkers.length; i++) {
          this.drawnMarkers[i].setMap(null)
        }
        this.drawnMarkers = []
      },
      drawPointsForSingle(locations) {
        this.clearMarkers()

        if (locations.length != 0) {
          this.map_info = 'Found ' + locations.length + ' GPS points from driver ' + locations[0]['id_user']['name_first'] + ' ' + locations[0]['id_user']['name_last'] + ' #' + locations[0]['id_user']['id_user'] + ' during this period.'

          for (let i = 0; i < locations.length; i++) {
            console.log(locations[i])
            let loc = locations[i]

            if (i == locations.length -1) {
              let image = {url: "https://verida.s3-us-west-2.amazonaws.com/car40.png"}

              let label2 = {
                color: 'red', // <= HERE
                fontSize: '11px',
                fontWeight: '900',
                text: loc['id_user']['name_first'] + ' ' + loc['id_user']['name_last'] + ' #' + loc['id_user']['id_user']
              }

              let marker2 = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
                icon: image,
                label: label2,
                map: this.map
              });

              this.drawnMarkers.push(marker2)
            }

            let label = {
              color: 'red', // <= HERE
              fontSize: '11px',
              fontWeight: '900',
              text: '' + i
            }

            let marker = new google.maps.Marker({
              position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 7,
                strokeColor: 'blue'
              },
              label: label,
              map: this.map,
              title: loc['id_user']['name_first'] + ' ' + loc['id_user']['name_last'] + ' ' + locations[i]['created_at']
            });

            this.drawnMarkers.push(marker)
          }
        }
      },
      drawPointsForDrivers(locations) {
        this.clearMarkers()

        if (locations.length != 0) {
          this.map_info = 'Found ' + locations.length + ' drivers that their GPS tracking was active during this period.'

          let image = {url: "https://verida.s3-us-west-2.amazonaws.com/car40.png"}

          for (let i = 0; i < locations.length; i++) {
            console.log(locations[i])
            let loc = locations[i]
            let label = {
              color: 'red', // <= HERE
              fontSize: '11px',
              fontWeight: '900',
              text: loc['id_user']['name_first'] + ' ' + loc['id_user']['name_last'] + ' #' + loc['id_user']['id_user']
            }

            let marker = new google.maps.Marker({
              position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
              icon: image,
              label: label,
              map: this.map,
              title: loc['id_user']['name_first'] + ' ' + loc['id_user']['name_last'] + ' ' + locations[i]['created_at']
            });

            this.drawnMarkers.push(marker)
          }
        }
      },
      searchDriverLocations: function () {
        this.showLoading()
        this.$http
          .get(process.env.API_BASE_URL_CS + 'locations/?type=drivers_map'
            + (this.id_driver ? '&id_driver=' + this.id_driver : '')
            + (this.min_date ? '&start=' + this.min_date : '')
            + (this.max_date ? '&end=' + this.max_date : '')
          )
          .then(response => {
            console.log(response)
            if (this.id_driver) {
              this.drawPointsForSingle(response['data'])
            } else {
              this.driversLocations = response['data'].reverse()
              this.drawPointsForDrivers(response['data'])
            }
          })
          .catch(error => {
            console.error(error)
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
          })
          .finally(() => {
            this.hideLoading()
          })
      },
      initMap: function () {
        google.maps.Polyline.prototype.simplify = function (tolerance) {

          var points = this.getPath().getArray(); // An array of google.maps.LatLng objects
          var keep = []; // The simplified array of points

          // Check there is something to simplify.
          if (points.length <= 2) {
            return points;
          }

          function distanceToSegment (p, v, w) {

            function distanceSquared (v, w) {
              return Math.pow((v.x - w.x), 2) + Math.pow((v.y - w.y), 2)
            }

            function distanceToSegmentSquared (p, v, w) {

              var l2 = distanceSquared(v, w);
              if (l2 === 0) return distanceSquared(p, v);

              var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
              if (t < 0) return distanceSquared(p, v);
              if (t > 1) return distanceSquared(p, w);
              return distanceSquared(p, {x: v.x + t * (w.x - v.x), y: v.y + t * (w.y - v.y)});
            }

            // Lat/Lng to x/y
            function ll2xy (p) {
              return {x: p.lat(), y: p.lng()};
            }

            return Math.sqrt(distanceToSegmentSquared(ll2xy(p), ll2xy(v), ll2xy(w)));
          }

          function dp (points, tolerance) {

            // If the segment is too small, just keep the first point.
            // We push the final point on at the very end.
            if (points.length <= 2) {
              return [points[0]];
            }

            var keep = [],  // An array of points to keep
              v = points[0], // Starting point that defines a segment
              w = points[points.length - 1], // Ending point that defines a segment
              maxDistance = 0, // Distance of farthest point
              maxIndex = 0; // Index of said point

            // Loop over every intermediate point to find point greatest distance from segment
            for (var i = 1, ii = points.length - 2; i <= ii; i++) {
              var distance = distanceToSegment(points[i], points[0], points[points.length - 1]);
              if (distance > maxDistance) {
                maxDistance = distance;
                maxIndex = i;
              }
            }

            // check if the max distance is greater than our tollerance allows
            if (maxDistance >= tolerance) {

              // Recursivly call dp() on first half of points
              keep = keep.concat(dp(points.slice(0, maxIndex + 1), tolerance));

              // Then on second half
              keep = keep.concat(dp(points.slice(maxIndex, points.length), tolerance));

            } else {
              // Discarding intermediate point, keep the first
              keep = [points[0]];
            }
            return keep;
          };

          // Push the final point on
          keep = dp(points, tolerance);
          keep.push(points[points.length - 1]);
          return keep;

        };

        var center_x = 33.637;
        var center_y = -84.431;

        var map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: center_x ? center_x : 33.637, lng: center_y ? center_y : -84.431},
          zoom: 9,
          minZoom: 7,
          draggableCursor: 'default',
          fullscreenControl: true,
          mapTypeControl: false,
          streetViewControl: false,
        })

        this.map = map;

        var drawingManager = new google.maps.drawing.DrawingManager({
          // drawingMode: google.maps.drawing.OverlayType.MARKER,
          drawingControl: false,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: []
          },
          markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
          polygonOptions: {
            fillColor: '#0074e4',
            fillOpacity: 1,
            strokeWeight: 5,
            clickable: false,
            editable: true,
            zIndex: 1
          }
        })
        drawingManager.setMap(map)


        this.searchDriverLocations()
      },
    },
    mounted () {
      // this.getDriver()
      if (!this.min_date) {
        let start = new Date()
        start.setHours(start.getHours() - 1)
        this.min_date = start.toISOString();
      }

      this.initMap()
    },
    created () {
      // document.title = "Wingz Support | Drivers";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .actions button {
    color: #333268;
    background-color: #00f9b9;
    border: none;
    margin-bottom: 5px;
  }

  .actions button:hover {
    background-color: red;
  }

  .card-map-body button {
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DriversMap.vue